import {Outlet} from "react-router";

export const AuthLayout = () => (
  <div
    className="min-h-screen flex items-center justify-center p-4"
    style={{
      background: "linear-gradient(135deg, var(--color-primary) 0%, #1a4a36 50%, #0d2a20 100%)",
    }}
  >
    <div className="w-full max-w-md">
      <Outlet />
    </div>
  </div>
);
